import { isDesktopApp } from './isDesktopApp.es.js';
import { getWebAppLink, getSupportLink, getGuestSiteLink, getSamplesLink, getSessionsLink, getNetworkLink, getEducationLink, getRedeemAProductLink, getStudioAILink } from './linksCreator.es.js';

const networkUrlRegex = /^network(-(dev|demo|partner))?\.landr\.com/;
const blogUrlRegex = /blog-?[a-z]*\.landr\.com/;
const pluginsMarketPlaceUrlRegex = /^plugins(-(dev|demo|partner))?\.landr\.com/;
const samplesUrlRegex = /^samples(-(dev|demo|partner))?\.landr\.com/;
const webAppUrlRegex = /^app(-(dev|demo|partner))?\.landr\.com/;
const isBrowser = typeof window !== 'undefined';
const openLink = (link, forceNewWindow = false) => {
    const url = new URL(link);
    const currentHost = isBrowser ? window.location.host : '';
    const isCurrentHostAndPort = currentHost === url.host;
    // When already Samples, using window.history.pushState doesn't register the page changes.
    const isUnsupportedLandrHost = currentHost.includes('samples');
    if (forceNewWindow) {
        window.open(link, '_blank');
    }
    else if (isCurrentHostAndPort && !isUnsupportedLandrHost) {
        window.history.pushState({}, '', link);
    }
    else {
        window.open(link, getWindowTarget(url));
    }
};
function getWindowTarget(url) {
    const currentHost = isBrowser ? window === null || window === void 0 ? void 0 : window.location.host : '';
    // Open network, plugins marketplace and samples in current tab even on desktop app
    if (networkUrlRegex.test(url.host) || pluginsMarketPlaceUrlRegex.test(url.host) || samplesUrlRegex.test(url.host)) {
        return '_self';
    }
    // When navigating back from another app than web app
    if ((networkUrlRegex.test(currentHost) ||
        blogUrlRegex.test(currentHost) ||
        samplesUrlRegex.test(currentHost) ||
        pluginsMarketPlaceUrlRegex.test(currentHost)) &&
        webAppUrlRegex.test(url.host)) {
        return '_self';
    }
    // Open blog in new tab
    if (blogUrlRegex.test(url.host)) {
        return '_blank';
    }
    return isDesktopApp() || !url.host.includes('landr.com') ? '_blank' : '_self';
}
const openWebAppLink = (env, pathname = '/', forceNewWindow = false) => {
    openLink(getWebAppLink(env, pathname), forceNewWindow);
};
const openSupportLink = (language, pathname = '/', forceNewWindow = true) => {
    openLink(getSupportLink(language, pathname), forceNewWindow);
};
const openGuestSiteLink = (env, pathname = '/', forceNewWindow = false) => {
    openLink(getGuestSiteLink(env, pathname), forceNewWindow);
};
const openSamplesLink = (env, pathname = '/', options = {
    isSamplesInWebApp: false,
    forceNewWindow: false,
}) => openLink(getSamplesLink(env, pathname, options), options.forceNewWindow);
const openSessionsLink = (env, pathname = '', forceNewWindow = false) => openLink(getSessionsLink(env, pathname), forceNewWindow);
const openNetworkLink = (env, pathname = '', options = {
    isNetworkAngularMfeInWebApp: false,
    forceNewWindow: false,
}) => openLink(getNetworkLink(env, pathname, options), options.forceNewWindow);
const openWebAppHomeLink = (env, forceNewWindow = false) => {
    openWebAppLink(env, '/dashboard', forceNewWindow);
};
const openEducationLink = (env, pathname = '/', forceNewWindow = false) => openLink(getEducationLink(env, pathname), forceNewWindow);
const openRedeemAProductLink = (env, pathname = '', forceNewWindow = false) => openLink(getRedeemAProductLink(env, pathname), forceNewWindow);
const openStudioAILink = (env, pathname = '', forceNewWindow = false) => {
    const link = getStudioAILink(env, pathname);
    // We are not using `openLink` here because the Studio app is not using client side navigation
    // We need to do a full refresh of the page to get the new page
    window.open(link, forceNewWindow ? '_blank' : '_self');
};

export { openEducationLink, openGuestSiteLink, openLink, openNetworkLink, openRedeemAProductLink, openSamplesLink, openSessionsLink, openStudioAILink, openSupportLink, openWebAppHomeLink, openWebAppLink };
